<div class="option-container">
    <p-dropdown [options]="years" (onChange)="changeYear($event.value)"></p-dropdown>
</div>
<p-table #dataTable [value]="payments">
    <ng-template pTemplate="header">
        <tr>
            <th>
                Booking ID
            </th>
            <th>
                School
            </th>
            <th>
                Active
            </th>
            <th>
                Name
            </th>
            <th>
                Inv. Number
            </th>
            <th>
                Departure
            </th>
            <th>
                Month
            </th>
            <th>
                Date
            </th>
            <th>
                Comment
            </th>
            <th>
                Amt
            </th>
            <th>
                Currency
            </th>
        </tr>
        <tr>
            <th>
                <input #idInput pInputText
                    (input)="dataTable.filter($any($event.target)?.value, 'bookingId', 'contains')"
                    [value]="$any(dataTable).filters['bookingId']?.value">
            </th>
            <th>
                <input #schoolNameInput pInputText
                    (input)="dataTable.filter($any($event.target)?.value, 'schoolName', 'contains')"
                    [value]="$any(dataTable).filters['schoolName']?.value">
            </th>
            <th></th>
            <th>
                <input #studentNameInput pInputText
                    (input)="dataTable.filter($any($event.target)?.value, 'studentName', 'contains')"
                    [value]="$any(dataTable).filters['studentName']?.value">
            </th>
            <th>
                <input #invoiceNumberInput pInputText
                    (input)="dataTable.filter($any($event.target)?.value, 'invoiceNumber', 'contains')"
                    [value]="$any(dataTable).filters['invoiceNumber']?.value">
            </th>
            <th>
                <p-calendar appendTo="body" (onSelect)="onStartDateSelect($event)"
                    (onClearClick)="dataTable.filter('', 'startDate', 'equals')" [inputStyle]="{'width':'100%'}"
                    [showButtonBar]="true" styleClass="ui-column-filter" placeholder="Start Date" [readonlyInput]="true"
                    dateFormat="dd/mm/yy"></p-calendar>
            </th>
            <th>
                <input #paidMonthInput pInputText
                    (input)="dataTable.filter($any($event.target)?.value, 'paidMonth', 'equals')"
                    [value]="$any(dataTable).filters['paidMonth']?.value">
            </th>
            <th>
                <p-calendar appendTo="body" (onSelect)="onPaymentDateSelect($event)"
                    (onClearClick)="dataTable.filter('', 'paidDate', 'equals')" [showButtonBar]="true"
                    [readonlyInput]="true" dateFormat="dd/mm/yy" [inputStyle]="{'width':'100%'}"></p-calendar>
            </th>
            <th>
                <input #commentInput pInputText
                    (input)="dataTable.filter($any($event.target)?.value, 'comment', 'contains')"
                    [value]="$any(dataTable).filters['comment']?.value">
            </th>
            <th>
                <input #amountInput pInputText
                    (input)="dataTable.filter($any($event.target)?.value, 'amount', 'contains')"
                    [value]="$any(dataTable).filters['amount']?.value">
            </th>
            <th>
                <p-multiSelect [options]="currencyIsoCodes" [(ngModel)]="selectedCurrencyIsoCodes"
                    (onChange)="dataTable.filter($event.value, 'currency.isoCode', 'in')"></p-multiSelect>
            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-payment>
        <tr>
            <td>
                <a routerLink="/management/edit-booking/{{payment.lvcId}}" target="_blank">
                    {{payment.bookingId}}
                </a>
            </td>
            <td>
                {{payment.schoolName}}
            </td>
            <td>
                <p *ngIf="payment.isActive">X</p>
            </td>
            <td>
                {{payment.studentName}}
            </td>
            <td>
                {{payment.invoiceNumber}}
            </td>
            <td>
                {{payment.startDate | date:'dd/MM/yyyy'}}
            </td>
            <td>
                {{payment.paidMonth}}
            </td>
            <td>
                {{payment.paidDate | date:'dd/MM/yyyy'}}
            </td>
            <td>
                {{payment.comment}}
            </td>
            <td>
                {{payment.amount}}
            </td>
            <td>
                {{payment.currency.isoCode}}
            </td>
        </tr>
    </ng-template>
</p-table>